import { fetch_request } from '../service/request';

const STORAGE_KEY = 'ng.guestCartToken';

export const getGuestCartToken = () => {
  if (typeof window === 'undefined') return '';
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
};

export const setGuestCartToken = (token) => {
  if (typeof window === 'undefined' || !token) return;
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {}
};

export const shouldRestoreGuestCart = ({ isAuth, token, restoredToken }) =>
  !isAuth && Boolean(token) && restoredToken !== token;

export const shouldSyncGuestCart = ({ isAuth, cartLength, token, restoredToken }) => {
  if (isAuth) return false;
  if (cartLength > 0) return true;
  return Boolean(token) && restoredToken === token;
};

export const syncGuestCart = async (cart) => {
  try {
    const token = getGuestCartToken();
    const res = await fetch_request('/guest_carts', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cart, token }),
    });
    if (res.ok) {
      const data = await res.json();
      if (data?.token) setGuestCartToken(data.token);
      return data?.token || token || '';
    }
  } catch (e) {
    console.warn('Failed to sync guest cart', e);
  }
  return getGuestCartToken();
};

export const fetchGuestCart = async (token) => {
  if (!token) return [];
  try {
    const res = await fetch_request(`/guest_carts/${token}`);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data?.cart) ? data.cart : [];
  } catch {
    return [];
  }
};
